if (!customElements.get('shoppable-looks')) {
  customElements.define('shoppable-looks', class ShoppableLooks extends HTMLElement {
    connectedCallback() {
      this._onClick = (e) => {
        const seasonTab = e.target.closest('[data-season-tab]');
        if (seasonTab) { this.activateSeason(seasonTab); return; }

        const categoryTab = e.target.closest('[data-category-tab]');
        if (categoryTab) {
          const seasonPanel = categoryTab.closest('[data-season-panel]');
          this.activateCategory(seasonPanel, categoryTab);
          return;
        }

        const subcatTab = e.target.closest('[data-subcat-tab]');
        if (subcatTab) {
          const categoryPanel = subcatTab.closest('[data-category-panel]');
          this.activateSubcatTab(categoryPanel, subcatTab);
          return;
        }
      };
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }

    activateSeason(tab) {
      const handle = tab.dataset.seasonTab;

      this.querySelectorAll('[data-season-tab]').forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.querySelectorAll('[data-season-panel]').forEach(p => p.classList.remove('is-active'));

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      const panel = this.querySelector(`[data-season-panel="${handle}"]`);
      if (panel) panel.classList.add('is-active');
    }

    activateCategory(seasonPanel, tab) {
      const handle = tab.dataset.categoryTab;

      seasonPanel.querySelectorAll('[data-category-tab]').forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      seasonPanel.querySelectorAll('[data-category-panel]').forEach(p => p.classList.remove('is-active'));

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      const panel = seasonPanel.querySelector(`[data-category-panel="${handle}"]`);
      if (panel) panel.classList.add('is-active');
    }

    activateSubcatTab(categoryPanel, tab) {
      const handle = tab.dataset.subcatTab;

      categoryPanel.querySelectorAll('[data-subcat-tab]').forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      categoryPanel.querySelectorAll('[data-subcat-panel]').forEach(p => p.classList.remove('is-active'));

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      const panel = categoryPanel.querySelector(`[data-subcat-panel="${handle}"]`);
      if (panel) panel.classList.add('is-active');
    }
  });
}
